export const environment = {
  production: false,
  swaggerUrl: 'https://api.development.ctrlchain.com/swagger/v1/swagger.json',
};
